import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as base64 from 'base-64';
import { LoginService } from '../login.service';
import { UtilsService } from '../utils.service';

@Component({
  selector: 'app-recuperacaosenha',
  templateUrl: './recuperacaosenha.component.html',
  styleUrls: ['./recuperacaosenha.component.css']
})
export class RecuperacaosenhaComponent implements OnInit {
  progressBar:boolean = false;
  email:string;
  senha:string;
  senhaConfirmacao:string;
  chave:string;

  constructor(public route: ActivatedRoute,
              private login:LoginService,
              private router:Router) { }

  ngOnInit() {
    this.chave = this.route.snapshot.paramMap.get('chave');
    let mchave = base64.decode(this.chave).split(":");

    let dt = new Date(parseInt(mchave[2]));
    let dtComp = new Date();

    if (dt.getDay() !== dtComp.getDay() || dt.getMonth() !== dtComp.getMonth() || dt.getFullYear() !== dtComp.getFullYear()) {
      UtilsService.alerta("Essa solicitação de alteração de senha já expirou!", "erro");
      this.router.navigate(["/login"]);
    }
  }

  salvar() {
    this.progressBar = true;
    this.login.alterarSenha({ "senha": this.senha, "token": this.chave}).subscribe((resp) => {
      this.progressBar = false;
      this.router.navigate(["/login"]);
    }, resp => {
      this.progressBar = false;
      UtilsService.alerta(resp.error.message, 'erro');
      this.router.navigate(["/login"]);
    });
  }

}
